import {createApi} from '@reduxjs/toolkit/query/react';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from '../../utils/API/requestMiddleware';
import { transformErrorResponse, transformSuccessResponse } from '../../utils/API/responseMiddleware';
const projectVersionAPI = createApi({
    reducerPath:"projectVersionAPI",
    baseQuery:customFetchBase,
    endpoints:(builder)=>({
        
        getAllProjectVersion: builder.query({
            query: () => ({
                url: `/ProjectDetailsManagement/GetAllProjectVersion`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getProjectVersionList:builder.mutation({
            query:(data)=>({
                url:"/ProjectDetailsManagement/GetProjectVersionList",
                method:"POST",
                body:transformRequest(data)
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse:transformErrorResponse,
        }),
        addProjectVersion: builder.mutation({
            query:(data) => ({
                url: `/ProjectDetailsManagement/AddProjectVersion`,
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteProjectVersion:builder.mutation({
            query:(projectVersionId)=>({
                url:`/ProjectDetailsManagement/DeleteProjectVersion?id=${projectVersionId}`,
                method:'DELETE',
                body:transformRequest(projectVersionId)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        
        getProjectVersionById: builder.query({
            query: (projectVersionId) => ({
                url: `/ProjectDetailsManagement/GetProjectVersionDetailsByID/?id=${Number(projectVersionId)}`,
                method: 'GET'
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProjectVersion: builder.mutation({
            query: (data) => ({
                url: '/ProjectDetailsManagement/UpdateProjectVersion',
                method: 'POST',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {
useLazyGetAllProjectVersionQuery,
useGetProjectVersionListMutation,
useAddProjectVersionMutation,
useDeleteProjectVersionMutation,
useLazyGetProjectVersionByIdQuery,
useUpdateProjectVersionMutation
} = projectVersionAPI;

export default projectVersionAPI;